import React from 'react';
import PageHeader from './Header';
import SearchBar from './SearchBar';

import MapMain from './MapMain';
import Setting from './Setting';

import { Layout,  Row, Col } from 'antd';
const { Header, Footer, Sider, Content } = Layout;

const MunicipalProfilePage = () => (
  <Layout>
    <Header className="header">
      <PageHeader />
    </Header>

    <Content>
      <Row>
        <SearchBar background="default"/>
      </Row>
      <Row>
          <div className="map-container">
            <MapMain />
          </div>

            <Setting />
      </Row>
    </Content>
    </Layout>

);

export default MunicipalProfilePage;



// WEBPACK FOOTER //
// ./src/components/MunicipalProfilePage.js